/** Sanitizes a `?redirect=` target so sign-out/-in can never loop into an open redirect. */
export function safeRedirect(raw: string | undefined | null): string {
  if (!raw || typeof raw !== 'string') {
    return '/';
  }
  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return '/';
  }
  const path = raw.split('?')[0].split('#')[0];
  const blocked = ['/login', '/logout', '/user/logout', '/forgot-password', '/update-password'];
  if (blocked.some(b => path === b || path.startsWith(`${b}/`))) {
    return '/';
  }
  return raw;
}
